"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFetched = isFetched;
exports.fetchImage = fetchImage;

var _q = _interopRequireDefault(require("q"));

var fetched = {};

function isFetched(src) {
  return fetched[src];
}

function fetchImage(src) {
  if (isFetched(src)) {
    return _q.default.Promise.resolve();
  }

  return new _q.default.Promise(function (resolve, reject) {
    var img = new Image();

    var onload = function onload() {
      fetched[src] = true;
      resolve();
    };

    img.onerror = reject;
    img.onload = onload;
    img.src = src;
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/lib/Image.js
// module id = 862
// module chunks = 209 210 211 212